import React, { forwardRef } from 'react'

import { IconProps } from './types'

const ArrowLeft = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M8 12L4 8M4 8L8 4M4 8L13 8" stroke={color} />
    </svg>
  ),
)

ArrowLeft.displayName = 'ArrowLeft'

ArrowLeft.defaultProps = {
  size: 16,
  color: 'currentColor',
}

export default ArrowLeft
